export default {
  title: 'Skift adgangskode',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Indtast e-mail',
    },
    new_password: {
      label: 'Ny adgangskode',
      placeholder: 'Indtast adgangskode',
      requirements: 'Din adgangskode skal indeholde 8 tegn, et stort bogstav og et tal',
    },
    confirm_password: {
      label: 'Bekræft ny adgangskode',
      placeholder: 'Bekræft adgangskode',
    },
    error_messages: {
      missing_info: 'Manglende oplysninger',
    },
  },
  buttons: {
    change_password: 'Skift adgangskode',
  },
};
